const DibbleTranslation = {
    en: {
        'global': {
            'buttons': {
                'search': 'Search',
                'add': 'Add',
                'delete': 'Delete',
                'save': 'Save',
            },
            'label': {
                'total': 'Total',
                'active': 'Active',
                'hidden': 'Hidden',
                'select': 'Select',
                'details': 'Details',
                'select_all': 'All',
                'none': 'None',
                'remove_confirm': 'Delete record?',
                'multiselect_record_selected': 'Selected',
                'multiselect_press_enter_label': 'Press enter to select',
                'multiselect_selected_label': 'Selected',
                'multiselect_deselect_label': 'Press enter to remove',
                'logout': 'Logout',
                'logout_confirm': 'Are you sure want to logout?',
                btn: {
                    confirm: 'Confirm',
                    cancel: 'Cancel'
                },
                'record': {
                    'empty': 'There is no data'
                },
                is: {
                    loading: 'Loading...'
                }
            },
            error: {
                'invalid_image_type': 'Invalid image',
                form: {
                    fields: 'Please complete all fields'
                },
                field: {
                    required: 'This field is required.',
                    complete_all: 'Please complete all fields.',
                    email_not_valid: 'Email format is not valid.'
                }
            }
        },
        'global.error.api.error': 'System error occurred.',
        'global.error.field.required': 'This field is required',
        'global.error.field.complete.all': 'Please complete all fields.',
        'global.error.form.fields': 'Please correct the form errors.',
        'global.label.record.empty': 'Data is empty',
        'categories.remove.confirm': 'Delete record?',

        'login': {
            'tagline': 'Dashboard Login',
            'placeholder': {
                'email': 'Login',
                'password': 'Password'
            },
            'button': {
                'login': 'Login'
            }
        },
        'global.label.btn.confirm': 'I confirm',
        'global.label.btn.cancel': 'Cancel',
        'global.label.is.loading': 'Updating...',

        /*| Dashboard |*/
        'sidebar': {
            'users': 'User List',
            'idols': 'Idols List ',
            'users_management': 'Users Management',
            'parameters': 'Parameters',
            'idols_to_approve': 'Idols to approve',
            'idol_categories': 'Idol Categories',
            'event_settings': 'Event Settings',
        },
        /*| End Menu |*/


        /*| Dashboard |*/
        'dashboard': {
            'go_back_settings': 'Settings',
            'tagline': 'Home Page Management',
            'recommended_products': 'Recommended for you',
            'categories': 'Categories',
            'count_products': 'products in the category',
            'banner': 'Banners',
            'count_products_2': 'products',
            'count_categories': 'categories',
            'save_warning': 'Notice! Review your changes before saving!',
            'button_save': 'Save',
            'modals': {
                'save': {
                    'are_you_sure': 'Are you sure?',
                    'content': 'The changes will be saved and shown to the users immediately, so pay attention to your changes again!',
                    'btn_save': 'Continue'
                },
                'add_product': {
                    'tagline': 'Add Product',
                    'notice_1': 'Add product for “recommended for you”.',
                    'notice_2': 'User the search box to find your products',
                    'search_placeholder': 'Can search by name of catalog number',
                    'search_no_keyword': 'Please specify the keyword!'
                },
                'add_category': {
                    'tagline': 'Add Category',
                    'notice_1': 'Add category for “Categories”.',
                    'notice_2': 'User the search box to find your category',
                    'search_placeholder': 'Can search by name of catalog number',
                    'search_no_keyword': 'Please specify the keyword!',
                    'product_count': 'products in the category'
                },
                'add_banner': {
                    'tagline': 'Add Banner',
                    'notice_1': 'Add banner for “Banners”.',
                    'notice_2': 'User the search box to find your banner',
                    'search_placeholder': 'Can search by name of catalog number',
                    'search_no_keyword': 'Please specify the keyword!',
                }
            }
        },
        /*| End Dashboard |*/

        /*| Users |*/
        'users': {
            'list': {
                'name': 'Full name',
                'registration_date': 'Registration date',
                'country': 'Country',
                'user_rating': 'User rating',
                'user_active':'Active',
                'user_inactive': 'InActive',
                'events': 'Events',
                'shnips': 'Shnips',
                'favorites': 'favorites',
                'no_of_users': 'מספר משתמש',
                'email': 'Email',
                'phone': 'Phone',
                'status': 'Status',
                'search_select_status_placeholder': 'Active/Inactive',
                'search_placeholder': 'Search for a keyword',
                'from_date': 'From Date',
                'to_date': 'To Date',
                'tagline': 'Users List',
                'favourites': 'Favorites'

            },
            'details': {
                'tagline': 'משתמש',
                'user_details': 'הצגת משתמש',
                'general_info': 'מידע כללי',
                'purchase_history': 'היסטורית הזמנות',
                'user_details_2': 'פרטי משתמש',
                'full_name': 'Full name',
                'first_name': 'First name',
                'first_name_placeholder': 'לדוגמא: ישראל',
                'last_name': 'Last name',
                'last_name_placeholder': 'לדוגמא: ישראלי',
                'mobile': 'מספר פלאפון',
                'mobile_placeholder': 'לדוגמא: 03-6270303',
                'email': 'Email',
                'email_placeholder': 'לדוגמא: workimhi@mail.com',
                'email_verified': 'מאומת',
                'email_not_verified': 'לא אומת',
                'user_address': 'כתובות המשתמש',
                'address': 'כתובת',
                'address_placeholder': 'לדוגמא: הארז 3 תל אביב',
                'floor': 'קומה',
                'floor_placeholder': 'לדוגמא: 3',
                'question_edit': 'משתמש זה מוצג לצפייה בלבד, צריך לערוך? לחץ על כפתור העריכה שמתחת',
                'btn_edit': 'עריכת משתמש',
                'events_list': 'Events List',
                'payments': 'Payments',
                'shnips': 'Shnips',
                'favorite': 'Favorites',
            }
        },
        /*| End Users |*/

        /*| Idos |*/
        'idols': {
            'list': {
                'full_name': 'Full name',
                'registration_date': 'Registration date',
                'no_likes': 'Number of likes',
                'no_private_views': 'Number of profile views',
                'country': 'Country',
                'user_active':'Active',
                'user_inactive': 'InActive',
                'events': 'Events',
                'shnips': 'Shnips',
                'favorites': 'favorites',
                'no_of_users': 'מספר משתמש',
                'email': 'Email',
                'phone': 'Phone',
                'status': 'Status',
                'search_select_status_placeholder': 'Active/Inactive',
                'search_placeholder': 'Search for a keyword',
                'from_date': 'From Date',
                'to_date': 'To Date',
                'is_verified': 'Is this account verified',
                'social_media': 'Social media',
                'likes': 'Likes',
                'profile_views': 'Profile views',
                'category': 'Category',
                'internalcategory': 'Internal Category',
                'tagline': 'Idols List'

            },
            'event':{
                'title': "Event’s Title",
                'image': 'Event’s image',
                'start_datetime': 'Date of event',
                'end_datetime': 'Time frame',
                'price': 'Price',
                'status': 'Status',
                'slots': 'Number of slots',
                'num_of_requests': 'Number of requests',
                'requests': 'Requests',
                'shnips':'Shnips'
            },
            'approve':{
                'tagline': 'Idols to approve'
            }

        },

        /*| User Events |*/
        'user_events': {
            'tagline': 'User Events list'
        },

        'idol_events': {
            'tagline': 'Idol Events list'
        },

        'idol_categories': {
            'list': {
                tagline: 'Idol Categories'
            },
            remove_confirm: 'Are you sure want to remove these records?',
            error_empty_category_remove: 'Choose category to remove.'
        }


    },
    he: {
        /*| Global |*/
        'global': {
            'buttons': {
                'search': 'חיפוש',
                'add': 'לְהוֹסִיף',
                'delete': 'לִמְחוֹק'
            },
            'label': {
                'total': 'סה"כ',
                'active': 'פעילים',
                'hidden': 'מוסתרים',
                'select': 'בחר',
                'details': 'פרטים',
                'btn': {
                    'confirm': 'אני מאשר',
                    'save': 'לשמור',
                    'cancel': 'לְבַטֵל',
                },
                'is': {
                    'loading': 'עִדכּוּן...',
                },
                'is_active': 'פעיל',
                'action': 'פעולות',
                'status': 'סטטוס',
                'select_default': 'הקלד או בחר מהרשימה',
                'select_all': 'הכל',
                'record': {
                    'empty': 'הנתונים ריקים',
                },
                'remove_confirm': 'למחוק רשומה?',
                'multiselect_record_selected': 'נבחר',
                'multiselect_press_enter_label': 'לחץ על Enter כדי לבחור',
                'multiselect_selected_label': 'נבחר',
                'multiselect_deselect_label': 'לחץ על Enter כדי להסיר',
                'logout_confirm': 'האם אתה בטוח שברצונך להתנתק?',
            },
            'error': {
                'api': {
                    'error': 'אירעה שגיאת מערכת.',
                },
                'field': {
                    'required': 'שדה חובה',
                    'complete': {
                        'all': 'מלא את כל השדות'
                    },
                },
                'form': {
                    'fields': 'אנא תקן את שגיאות הטופס.',
                },
                'invalid_image_type': 'תמונה לא חוקית'
            }
        },
        /*| End Global |*/

        /*| Login |*/
        'login': {
            'tagline': 'התחברות',
            'placeholder': {
                'email': 'דוא"ל',
                'lpassword': 'סיסמא',
            },
            'button': {
                'login': 'כניסה'
            },
        },
        /*| End Login |*/

        'logout_btn': 'יציאה',

        /*| Dashboard |*/
        'dashboard': {
            'go_back_settings': 'הגדרות',
            'tagline': 'עריכת עמוד בית',
            'recommended_products': 'מומלצים עבורך',
            'categories': 'קטגוריות',
            'count_products': 'מוצרים נמצאים בקטגוריה',
            'banner': 'באנרים',
            'count_products_2': 'מוצרים',
            'count_categories': 'קטגוריות',
            'save_warning': 'שים לב! וודא את השינויים לפני שמירת הקובץ!',
            'button_save': 'שמור שינויים',
            'modals': {
                'save': {
                    'are_you_sure': 'האם אתה בטוח?',
                    'content': 'השינויים ישמרו ויוצגו למשתמשים באופן מידי, לכן חשוב לוודא את השינויים שוב!',
                    'btn_save': 'המשך'
                },
                'add_product': {
                    'tagline': 'הוספת מוצר',
                    'notice_1': 'הוסף מוצר עבור ״מומלצים עבורך״,',
                    'notice_2': 'השתמש בחיפוש בשביל למצוא את המוצר הרצוי',
                    'search_placeholder': 'ניתן לחפש על ידי שם או מק״ט',
                    'search_no_keyword': 'אנא ציין את מילת המפתח!'
                },
                'add_category': {
                    'tagline': 'הוספת קטגוריה',
                    'notice_1': 'הוסף קטגוריה עבור ״קטגוריות",',
                    'notice_2': 'השתמש בחיפוש בשביל למצוא את הקטגוריה הרצויה',
                    'search_placeholder': 'ניתן לחפש על ידי שם או מק״ט',
                    'search_no_keyword': 'אנא ציין את מילת המפתח!',
                    'product_count': 'מוצרים נמצאים בקטגוריה'
                },
                'add_banner': {
                    'tagline': 'הוספת באנר',
                    'notice_1': 'הוסף באנר עבור באנרים",',
                    'notice_2': 'השתמש בחיפוש בשביל למצוא את הבאנר הרצו',
                    'search_placeholder': 'ניתן לחפש על ידי שם או מק״ט',
                    'search_no_keyword': 'אנא ציין את מילת המפתח!',
                }
            }
        },
        /*| End Dashboard |*/

        /*| Categories |*/
        'categories': {
            'tagline': 'ניהול קטגוריות',
            'list': {
                'image': 'תמונה',
                'products_qty': 'כמות מוצרים',
                'name': 'שם הקטגוריה',
                'remove_confirm': 'למחוק רשומה?',
                'search': {
                    'placeholder': 'חיפוש',
                    'btn': 'חיפוש',
                },
            },
            'edit': {
                'category': 'ערוך קטגוריה',
                'buttons': {
                    'save': 'שמור',
                }
            },
            'add': {
                'category': 'הוספת קטגוריה',
                'name': 'שם הקטגוריה',
                'placeholder': {
                    'name': 'לדוגמא: כלים חשמליים',
                    'description': 'תאר בקצרה את הקטגוריה',
                    'image': 'גרור וזרוק את התמונה בשדה או',
                },
                'description': 'תיאור הקטגוריה (אופציונלי)',
                'parent': 'קטגורית אב (אופציונלי)',
                'image': 'תמונה',
                'buttons': {
                    'image': 'העלה תמונה',
                    'save': 'צור קטגוריה חדשה',
                },

                'active': 'קטגוריה פעילה',

                'errors': {
                    'name': 'שם הקטגוריה לא תקין.'
                },
            },
        },

        /*| End Categories |*/

        /*| Banners |*/
        'banners':{
            'tagline': 'ניהול באנרים',
            'none': 'ללא',
            'list':{
                'image': 'תמונה',
                'description': 'תיאור הבאנר',
                'last_update': 'תאריך עדכון',
                'name': 'שם הבאנר',
                'search':{
                    'placeholder': 'חיפוש',
                    'btn': 'חיפוש',
                }
            },
            'remove' : {
                'confirm': 'למחוק רשומה?'
            },
            'add_category': 'הוספת באנר',
            'edit_category': 'ערוך באנר',

            'add':{
                'name': 'שם הבאנר',
                'placeholder': {
                    'name': 'לדוגמא: כלים חשמליים',
                    'description': 'תאר בקצרה את הבאנר',
                    'image': 'גרור וזרוק את התמונה בשדה או',
                },
                'description': 'תיאור הבאנר (אופציונלי)',
                'parent': 'מקושר לקטגוריה (אופציונלי)',
                'image': 'תמונה',
                'button.image': 'העלה תמונה',
                'active': 'באנר פעיל',
                'btn_save': 'צור באנר חדש',
                'btn.back.to.add': 'בטל את העריכה',

                'error_name': 'שם הבאנר לא תקין.',
            },

            'edit':{
                'btn':{
                    'save': 'שמור',
                }
            }
        },
        /*| End Banners |*/

        /*| Products |*/
        'products': {
            'list': {
                'tagline': 'רשימת מוצרים',
                'buttons': {
                    'import': 'ייבוא מוצרים',
                    'add': 'הוסף מוצר',

                },
                'select_category': 'בחר קטגוריה',
                'picture': 'תמונה',
                'name': 'שם המוצר',
                'categories': 'קטגוריות',
                'product_count_1': ' מוצרים',
                'product_count_2': 'מציג תוצאות עבור:',
                'update_status': 'עדכון מצב',
                'popular': 'הנמכרים ביותר',
                'show_all': 'הצג הכל',
                'most_viewed': 'הנצפים ביותר',
                'status': 'מצב המוצרים',
                'remove_confirm': 'למחוק רשומה?',
            },
            'add': {
                'product_list': 'רשימת מוצרים',
                'label_add': 'הוספת מוצר חדש',
                'label_edit': 'עריכת מוצר',
                'general_info': 'מידע כללי',
                'product_name': 'שם המוצר',
                'placeholder_name': 'הכנס שם למוצר',
                'item_description': 'תיאור המוצר <span/>(אופציונאלי)<span>',
                'product_images': 'תמונות המוצר',
                'drag_product_images': 'גרור וזרוק את התמונות בשדה או',
                'upload_image': 'העלה תמונות',
                'technical_details': 'מפרט טכני <span/>(אופציונאלי)<span>',
                'field_name': 'שם השדה',
                'field_name_placeholder': 'לדוגמא: יצרן',
                'field_description': 'תיאור השדה',
                'field_description_placeholder': 'לדוגמא: מקיטה',
                'button_add_field': 'הוסף שדה',
                'fill_all_notice': 'יש בעייה עם שדה אחד או יותר,  אנא מלא את השדות החסרים לפני הפרסום',
                'button_publish_product': 'פרסם מוצר',
                'product_visual': 'ניראות המוצר',
                'define_product_visual': 'הגדר את ניראות המוצר עבור הלקוחות',
                'show_product': 'הצג את המוצר',
                'preview': 'תצוגה מקדימה',
                'preview_hint': 'צפה בתצוגה מקדימה של המוצר, באותה צורה שבה המשתמשים יראו את המוצר באתר. ',
                'price': 'מחיר',
                'enter_price': 'הכנס את מחיר המוצר כולל מע"מ',
                'including_vat': 'המוצר כולל מע״מ',
                'normal_price': 'מחיר רגיל',
                'price_placeholder': 'לדוגמא: 199.99',
                'sale_price_placeholder': 'לדוגמא: 99.99',
                'sale_price': 'מחיר מבצע <span/>(אופציונאלי)<span>',
                'catalog_number': 'מק"ט (מספר קטלוגי)',
                'catalog_number_hint': 'הכנס את המספר הקטגלוגי של המוצר',
                'catalog_number_placeholder': 'לדוגמא: 1234567',
                'categories': 'קטגוריות',
                'categories_hint': 'בחר קטגוריות מתאימות עבור המוצר על מנת שללקוחות יהיה קל יותר למצוא את המוצר',
                'tags': 'תגיות <span/>(אופציונאלי)<span>',
                'tag_placeholder': 'הוסף תג',
                'tags_hint': 'הוסף תגיות למוצר בשביל לקדם את המוצר במנועי החיפוש ',
                'main_image': 'תמונה ראשית',
                'errors': {
                    'product_name': 'שם המוצר חייב להכיל לפחות 2 תווים.',
                    'fields': 'יש בעייה עם שדה אחד או יותר,  אנא מלא את השדות החסרים לפני הפרסום',
                    'no_image': 'לא ניתן לפרסם מוצר ללא תמונה.',
                    'no_price': 'הכנס מחיר.',
                    'no_catalog': 'הכנס מספר מק״ט.',
                    'no_category': 'בחר קטגוריה אחת לפחות.',
                    'remove_technical_row': 'לא ניתן למחוק את השורה האחרונה!',
                },
                'delivery_return_options': 'אפשרויות שילוח והחזרה',
                'need_crane': 'מוצר זה חייב שילוח במנוף',
                'can_return': 'מוצר זה לא ניתן להחזרה',
                'options': {
                    'title': 'אפשרויות בחירה <span/>(אופציונאלי)<span>',
                    'description': 'למוצר זה יש אפשרויות מרובות, כמו גדלים או צבעים שונים',
                    'field_name': 'שם השדה',
                    'field_name_placeholder': 'לדוגמא: אורך הבורג',
                    'badges_list': 'אפשרויות הבחירה',
                    'manage_options': 'ניהול אפשרויות',
                    'label_option': 'אפשרות',
                    'label_price': 'מחיר'
                }
            }
        },
        /*| End Products |*/

        /*| Orders |*/
        'orders': {
            'active': {
                'tagline': 'מרכז ההזמנות',
                'select_status': 'בחר סטאטוס הזמנה',
                'select_date': 'בחר תאריכים',
                'business_account': 'חשבון עסקי',
                'regular_account': 'חשבון רגיל',
                'suppliers_made_bids': 'ספקים שהגישו הצעה',
                'order_total': 'עסקה על סך',
                'more_information': 'למידי נוסף',
                'status_update': 'עדכון מצב',
                'sale_this_week': 'מכירות השבוע',
                'sale_this_month': 'מכירות החודש',
                'order_status': 'מצב ההזמנות',
                'today': 'מהיום',
                'waiting': 'בהמתנה',
                'delivered': 'נמסרו',
                'cancelled': 'בוטלו'
            },
            'quick_look': {
                'tagline': 'פירוט ההזמנה',
                'order_total': 'סיכום הזמנה',
                'delivery_fee': 'דמי משלוח',
                'payment_total': 'סך הכל לתשלום',
                'quick_look': 'מבט זריז',
                'est_delivery_time': 'זמן מוערך למסירה',
                'order_place_time': 'תאריך ביצוע ההזמנה',
                'delivery_person': 'שליח',
                'contact': 'צור קשר',
                'payment_method': 'אמצעי תשלום'
            },
            'details': {
                'back_to_orders': 'מרכז ההזמנות',
                'tagline': 'פירוט ההזמנה',
                'payment_status': 'סטאטוס תשלום',
                'change_status': 'שנה סטאטוס',
                'order_number': 'הזמנה מספר',
                'order_details': 'פירוט ההזמנה',
                'order_total': 'סיכום הזמנה',
                'delivery_fee': 'דמי משלוח',
                'payment_total': 'סך הכל לתשלום',
                'quick_look': 'מבט זריז',
                'est_delivery_time': 'זמן מוערך למסירה',
                'change_time': 'שנה זמן',
                'place_time': 'תאריך ביצוע ההזמנה',
                'delivery_person': 'שליח',
                'contact': 'צור קשר',
                'payment_method': 'אמצעי תשלום',
                'address': 'כתובת',
                'change_address': 'שנה כתובת',
                'supplier_details': 'פרטי העסק',
                'email': 'דואר אלקטרוני',
                'phone': 'טלפון',
                'history': 'היסטוריה',
                'order_placed': 'ההזמנה נוצרה',
                'order_in_preparation': 'ההזמנה באריזה',
                'order_is_ready_for_delivery': 'ההזמנה מוכנה לאיסוף',
                'picked_by': 'ההזמנה נאספה על ידי השליח'
            }
        },
        /*| End Orders |*/

        /*| Suppliers |*/
        'suppliers': {
            'list': {
                'tagline': 'ניהול ספקים',
                'button': {
                    'add': 'הוסף'
                },
                'item_count': 'מציג תוצאות עבור:',
                'item_count_2': 'פריטים',
                'search': 'חיפוש ספק',
                'number': 'מספר',
                'name': 'שם הספק',
                'phone': 'מספר טלפון',
                'address': 'כתובת',
                'date_added': 'תאריך הוספה'
            },
            'create': {
                'add_title': 'הוספת ספק חדש',
                'edit_title': 'עריכת ספק',
                'general_information': 'מידע כללי',
                'deliveries': 'משלוחים',
                'account_details': 'פרטי חשבון',
                'supplier_details': 'פרטי ספק',
                'business_name': 'שם העסק <span/>(כפי שמופיע ברשם החברות)<span>',
                'business_name_placeholder': 'לדוגמא: האחים יחזקאל שיפוצים ואינסטלציה',
                'company_number': 'מספר ח.פ',
                'company_number_placeholder': 'לדוגמא: 30021993',
                'phone_number': 'מספר טלפון',
                'phone_number_placeholder': 'לדוגמא: 077-9110411',
                'email_address': 'כתובת דואר אלקטרוני <span/>(לשליחת חשבוניות ועדכונים)<span>',
                'email_address_placeholder': 'לדוגמא: example@mail.com',
                'business_address': 'כתובת העסק',
                'business_address_placeholder': 'לדוגמא: זאב ז׳בוטינסקי 2, רמת גן',
                'floor_number': 'קומה / מספר בית',
                'floor_number_placeholder': 'לדוגמא: קומה 26',
                'business_logo': 'לוגו העסק <span/>(אופציונלי)<span>',
                'drag_drop_placeholder': 'גרור וזרוק את התמונה בשדה או',
                'contact_details': 'פרטי איש קשר',
                'full_name': 'שם מלא',
                'full_name_placeholder': 'לדוגמא: ישראל ישראלי',
                'mobile_phone': 'מספר פלאפון',
                'mobile_phone_placeholder': 'לדוגמא: 054-5282828',
                'login_credentials': 'פרטי התחברות',
                'email': 'דואר אלקטרוני',
                'enter_email_address': 'הכנס כתובת דואר אלקטרוני',
                'password': 'סיסמא',
                'enter_password': 'הכנס סיסמא',
                'mandatory_fields': 'אנא מלא את כל שדות החובה לפני הוספת הספק',
                'button': {
                    'back_to_suppliers': 'ניהול ספקים',
                    'verify_email': 'אימות דואר',
                    'upload_image': 'העלה תמונה',
                    'verify_number': 'אימות מספר',
                    'add_supplier': 'הוסף ספק',
                    'update_supplier': 'עדכן ספק'
                },
                'opening_hours': 'שעות הפעילות',
                'opening_hours_placeholder': 'הגדר את שעות הפעילות של הספק על מנת שנדע לנתב את ההזמנות בצורה הטובה ביותר',
                'checkbox_open': 'פתוח',
                'checkbox_closed': 'סגור',
                'errors': {
                    'business_name': 'שם העסק חייב להכיל לפחות 2 תווים.',
                    'company_number': 'מספר ח.פ חייב להכיל לפחות 2 תווים.',
                    'phone_number': 'מספר הטלפון לא תקין.',
                    'email': 'כתובת דואר האלקטרוני לא תקינה.',
                    'business_address': 'כתובת העסק לא תקינה.',
                    'business_image': 'לא ניתן לפרסם מוצר ללא תמונה.',
                    'full_name': 'שם איש הקשר חייב להכיל לפחות 2 תווים.',
                    'mobile_phone': 'מספר הפלאפון לא תקין.',
                    'enter_email_address': 'כתובת דואר האלקטורני לא תקינה.',
                    'password': 'על הסיסמה להכיל לפחות 8 תווים, ועליה לכלול לפחות ספרה אחת ולפחות אות אחת בלועזית',
                    'password_validate': 'הסיסמה צריכה להיות לפחות 8 תווים ולפחות ספרה אחת ולפחות אות זרה אחת.',
                    'remove_delivery_row': 'לא ניתן למחוק את השורה האחרונה!',
                    'select_bank': 'בחר בנק',
                    'select_bank_branch': 'בחר סניף בנק'
                },
                'w_days': {
                    'sun': 'ראשון',
                    'mon': 'שני',
                    'tue': 'שלישי',
                    'wed': 'רביעי',
                    'thu': 'חמישי',
                    'fri': 'שישי',
                    'sat': 'שבת'
                },
                'delivery_settings': 'הגדרות משלוח',
                'est_time_arrival': 'תוך כמה זמן נגיע בדקות',
                'minutes': 'דקות',
                'min_order_cost': 'מינימום הזמנה עבור משלוח',
                'ils': 'ש"ח',
                'free_delivery_from': 'מינימום הזמנה עבור משלוח חינם',
                'delivery_radius': 'רדיוס משלוחים',
                'up_to': 'עד',
                'km': 'ק"מ',
                'cost': 'המחיר הוא',

                'account_holder_details': 'פרטי בעל החשבון',
                'first_name': 'שם פרטי',
                'first_name_placeholder': 'ישראל',
                'last_name': 'שם משפחה',
                'last_name_placeholder': 'ישראלי',
                'id_number': 'תעודת זהות',
                'id_placeholder': '123456789',
                'bank_account': 'פרטי חשבון הבנק',
                'bank_name': 'בנק',
                'type_or_select': 'הקלד או בחר מהרשימה',
                'branch_number': 'הסניף',
                'account_number': 'מספר חשבון',
                'account_number_placeholder': 'הכנס מספר חשבון',
                'account_commission': 'עמלות חשבון',
                'delivery_commission': 'עמלת הזמנה במשלוח',
                'pickup_commission': 'עמלת הזמנה באיסוף עצמי',
                'address_gmap_populated': 'כתובת המאוכלסת במפה',
                'modals': {
                    'verify_email': {
                        'verify_code': 'הכנס את קוד האימות שאיש הקשר קיבל בהודעה',
                        'code_sent': 'קוד האימות נשלח',
                        'btn_resend': 'הקוד לא הגיע? שלח שוב',
                        'btn_verify': 'תאשר',
                        'code_invalid': 'קוד לא תקין.'
                    },
                }
            }
        },
        /*| End Suppliers |*/

        /*| Users |*/
        'users': {
            'list': {
                'name': 'Full name',
                'registration_date': 'Registration date',
                'country': 'Country',
                'user_rating': 'User rating',
                'user_active':'Active',
                'user_inactive': 'InActive',
                'events': 'Events',
                'shnips': 'Shnips',
                'favorites': 'favorites',
                'no_of_users': 'מספר משתמש',
                'email': 'Email',
                'phone': 'Phone',
                'status': 'Status',
                'search_select_status_placeholder': 'Active/Inactive',
                'search_placeholder': 'Search',
                'from_date': 'From Date',
                'to_date': 'To Date',

            },
            'details': {
                'tagline': 'משתמש',
                'user_details': 'הצגת משתמש',
                'general_info': 'מידע כללי',
                'purchase_history': 'היסטורית הזמנות',
                'user_details_2': 'פרטי משתמש',
                'full_name': 'Full name',
                'first_name': 'First name',
                'first_name_placeholder': 'לדוגמא: ישראל',
                'last_name': 'Last name',
                'last_name_placeholder': 'לדוגמא: ישראלי',
                'mobile': 'מספר פלאפון',
                'mobile_placeholder': 'לדוגמא: 03-6270303',
                'email': 'Email',
                'email_placeholder': 'לדוגמא: workimhi@mail.com',
                'email_verified': 'מאומת',
                'email_not_verified': 'לא אומת',
                'user_address': 'כתובות המשתמש',
                'address': 'כתובת',
                'address_placeholder': 'לדוגמא: הארז 3 תל אביב',
                'floor': 'קומה',
                'floor_placeholder': 'לדוגמא: 3',
                'question_edit': 'משתמש זה מוצג לצפייה בלבד, צריך לערוך? לחץ על כפתור העריכה שמתחת',
                'btn_edit': 'עריכת משתמש'
            }
        }
        /*| End Users |*/
    },
    trans: function (key, fallbackLocale = 'en') {
        let dict = this[fallbackLocale];
        const objects = key.split('.');
        for (let i in objects) {
            if (typeof dict[objects[i]] !== 'undefined') {
                dict = dict[objects[i]];
            }
        }

        return typeof dict === 'string' ? dict : '';
    },
}

export default DibbleTranslation;
